import { observer } from "mobx-react";
import React from "react";
import CheckMarkIcon from "../../../../../images/membership/circle-check-mark.svg";
import SetupIcon from "../../../../../images/membership/setup.svg";
import { PricingPageService } from "../services";
import { ItemBillingType } from "../enums";
import { PricingPageInputModel } from "../models";
import {
  DescriptionCell,
  LabelCell,
  ProductDetailWrapper,
  SetupDetails,
} from "../styles";
import { CustomLabel, FlexContainer, IconButton, InfoIcon, Input, nameof, ToggleSwitch } from "@mindmemobile/mm-shared-global";

type Props = {
  pricingPageData: PricingPageService;
  headerCaption?: string;
  index: number;
  hideTermPlusRecurrence?: boolean;
};
@observer
export default class SetupSection extends React.Component<Props> {
  onBillingTypeChange(billingType: ItemBillingType) {
    this.props.pricingPageData.updatePrice(
      new PricingPageInputModel({
        ...this.editablePrice,
        billingType: billingType,
      }),
      this.props.index
    );
  }

  get billingSection() {
    return (
      <FlexContainer className="label-description-row">
        <LabelCell>
          <CustomLabel lineHeight="50px" fontSize="16px">
            Billing Type
          </CustomLabel>
          <InfoIcon />
        </LabelCell>
        <DescriptionCell>
          <FlexContainer spacing={15} fxWrap="wrap">
            {this.props.pricingPageData
              ?.billingOptions(this.props.index)
              ?.map((option, idx) => {
                if (
                  this.props.hideTermPlusRecurrence &&
                  option.key === ItemBillingType.TermPlusRecurring
                ) {
                  return null;
                }
                return (
                  <IconButton
                    onClick={() =>
                      this.onBillingTypeChange(option.key as ItemBillingType)
                    }
                    key={idx}
                    className={`action-button ${option.activeClass}`}
                  >
                    <img src={option.icon} />
                    {option.label}
                  </IconButton>
                );
              })}
          </FlexContainer>
        </DescriptionCell>
      </FlexContainer>
    );
  }

  onChange(value: string | boolean, key: keyof PricingPageInputModel) {
    let price: PricingPageInputModel | null = null;
    switch (key) {
      case nameof<PricingPageInputModel>("name"):
        price = new PricingPageInputModel({
          ...this.editablePrice,
          name: value.toString(),
        });
        break;
      case nameof<PricingPageInputModel>("description"):
        price = new PricingPageInputModel({
          ...this.editablePrice,
          description: value.toString(),
        });
        break;
      case nameof<PricingPageInputModel>("isActive"):
        price = new PricingPageInputModel({
          ...this.editablePrice,
          isActive: Boolean(value),
        });
        break;
    }

    if (price) {
      this.props.pricingPageData.updatePrice(price, this.props.index);
    }
  }

  textow(
    label: string,
    key: keyof PricingPageInputModel,
    value: string,
    placeholder: string
  ) {
    const showDefaultPriceCheck =
      key === nameof<PricingPageInputModel>("isDefault");
    const hasError = this.editablePrice?.errors.find((x) => x.field === key);
    return (
      <FlexContainer className="label-description-row">
        <LabelCell>
          <CustomLabel lineHeight="40px" fontSize="16px">
            {label}
          </CustomLabel>
          <InfoIcon />
        </LabelCell>
        <DescriptionCell>
          <FlexContainer spacing={15} fxLayout="row" className="price-field">
            <Input
              value={value}
              error={hasError}
              type="text"
              placeholder={placeholder}
              onChange={(e) => {
                this.onChange(e.target.value, key);
              }}
            />
            {showDefaultPriceCheck && (
              <span>
                <img src={CheckMarkIcon} className="check-icon" />
                This is the default price
              </span>
            )}
          </FlexContainer>
        </DescriptionCell>
      </FlexContainer>
    );
  }

  get editablePrice() {
    return this.props.pricingPageData.prices[this.props.index];
  }
  render() {
    return (
      <ProductDetailWrapper>
        <SetupDetails>
          <CustomLabel
            fontSize="22px"
            fontWeight="bold"
            lineHeight="22px"
            margin="40px 0px 0px"
            className="setup"
          >
            <img src={SetupIcon} /> Setup
          </CustomLabel>
          {this.billingSection}
          {this.textow(
            "Price Name",
            nameof<PricingPageInputModel>("name"),
            this.editablePrice.name,
            ""
          )}
          {this.textow(
            "Price Description",
            nameof<PricingPageInputModel>("description"),
            this.editablePrice.description,
            ""
          )}
          <FlexContainer className="label-description-row">
            <LabelCell>
              <CustomLabel lineHeight="40px" fontSize="16px">
                Price Status
              </CustomLabel>
            </LabelCell>
            <DescriptionCell>
              <ToggleSwitch
                on={this.editablePrice.isActive}
                onChange={(value) =>
                  this.onChange(
                    value,
                    nameof<PricingPageInputModel>("isActive")
                  )
                }
              />
            </DescriptionCell>
          </FlexContainer>
        </SetupDetails>
      </ProductDetailWrapper>
    );
  }
}
